import Component from '../Component';
import Header from './Header';
import Content from './Content';

class SidePanel extends Component {
    constructor() {
        super();

        this.key = 'side-panel';

        this.header = new Header({
            handleClose: this.close.bind(this),
        });
        this.content = new Content();
    }

    componentDidMount() {
        this.header.setRefs(this.refs);
        this.content.setRefs(this.refs);

        this.header.componentDidMount();
        this.content.componentDidMount();
    }

    open() {
        this.component.classList.add('active');
    }

    close() {
        this.component.classList.remove('active');
    }

    setupEventListeners() {
        this.childComponents.forEach((component) => {
            if (component.getClassName() === 'js-sidepanel-item') {
                component.setupEventListeners();
            }
        });
    }

    render() {
        return `
            <div ref="component-${this.key}" class="sidepanel">
                ${this.header.render()}
                <div class="sidepanel__content">
                    ${this.content.render()}
                </div>
            </div>
        `;
    }
}

export default SidePanel;